
import React from 'react';
import { FacilityOrderTemplateAddNoteModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateAddNoteModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateAddNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateAddNoteModalStore')
@observer
class FacilityOrderTemplateAddNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateAddNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateAddNoteModal;
